import {
  globalSearchParamsSchema,
  SEARCH_PARAM_ORG_ID,
  SEARCH_PARAM_SITE_ID,
} from 'routes/(global_search_params)/-searchParams'
import { GeckoEntry, RolodexEntryType } from 'types'
import { z } from 'zod'

export const SEARCH_PARAM_ENTRY_ID = 'entryId'

export const prismSearchParams = z.object({
  ...globalSearchParamsSchema.shape,
  [SEARCH_PARAM_ENTRY_ID]: z.string(),
})

export type PrismSearchParams = z.infer<typeof prismSearchParams>

type PrismOrgSiteIds = Pick<PrismSearchParams, 'orgId' | 'siteId'>

export function createPrismSearch({
  entryId,
  orgId,
  siteId,
}: PrismSearchParams): PrismSearchParams {
  return {
    [SEARCH_PARAM_ENTRY_ID]: entryId,
    [SEARCH_PARAM_ORG_ID]: orgId,
    [SEARCH_PARAM_SITE_ID]: siteId,
  }
}

function getPrismOrgSiteIds(
  entry: GeckoEntry,
  fallback: PrismOrgSiteIds = {
    orgId: undefined,
    siteId: undefined,
  }
): PrismOrgSiteIds {
  if (entry.type === RolodexEntryType.ORGANIZATION) {
    return {
      orgId: entry.id,
      siteId: undefined,
    }
  }

  if (entry.type === RolodexEntryType.SITE) {
    return {
      orgId: entry.tags.organization ?? fallback.orgId,
      siteId: entry.id,
    }
  }

  return {
    orgId: entry.tags.organization ?? fallback.orgId,
    siteId: entry.tags.site ?? fallback.siteId,
  }
}

export function createPrismSearchFromEntry(
  entry: GeckoEntry,
  fallback: PrismOrgSiteIds = {
    orgId: undefined,
    siteId: undefined,
  }
): PrismSearchParams {
  const { orgId, siteId } = getPrismOrgSiteIds(entry, fallback)

  return createPrismSearch({
    entryId: entry.id,
    orgId,
    siteId,
  })
}
